import React, { useEffect, useState, useCallback } from 'react';
import api from '../../lib/api';
import { toast } from 'sonner';
import { Info } from 'lucide-react';

function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('sv-SE', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
  });
}

const CustomerSupportSessionWidget = () => {
  const [active, setActive] = useState([]);
  const [revoking, setRevoking] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.get('/admin/support-sessions/customer');
      const rows = Array.isArray(r.data) ? r.data : [];
      const now = new Date();
      setActive(rows.filter((s) => !s.revoked_at && new Date(s.expires_at) > now));
    } catch (err) {
      setActive([]);
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 60_000);
    return () => clearInterval(id);
  }, [load]);

  const handleRevoke = async (sessionId) => {
    if (!window.confirm('Avsluta plattformsleverantörens åtkomst?')) return;
    setRevoking(sessionId);
    try {
      await api.delete(`/admin/support-sessions/${sessionId}`);
      toast.success('Supportåtkomst avslutad');
      load();
    } catch (err) {
      toast.error('Kunde inte avsluta sessionen');
    } finally {
      setRevoking(null);
    }
  };

  if (active.length === 0) return null;

  return (
    <div
      data-testid="customer-support-session-widget"
      className="rounded p-4"
      style={{ background: '#eff6ff', borderLeft: '4px solid #2563eb' }}
    >
      <div className="flex items-start gap-3">
        <Info size={20} className="text-blue-700 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <p className="font-semibold text-blue-900">
            Plattformsleverantören har aktiverat supportläge
          </p>
          {active.map((s) => (
            <div key={s.id} className="mt-2 text-sm text-blue-900">
              <p><strong>Anledning:</strong> {s.reason}</p>
              <p className="mt-1">
                <strong>Utgår:</strong> {formatDate(s.expires_at)} · <strong>API-anrop:</strong> {s.access_count}
              </p>
              <button
                onClick={() => handleRevoke(s.id)}
                disabled={revoking === s.id}
                className="mt-2 text-sm font-semibold underline text-blue-900 disabled:opacity-50"
              >
                {revoking === s.id ? 'Avslutar...' : 'Avsluta åtkomst'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerSupportSessionWidget;
